import React, { ReactElement } from 'react';
import { Box, Grid } from '@material-ui/core';
import { ComparisonLayout } from '../../../models/models';

import './layout-icon.styles.scss';

export interface ILayoutIconProps {
	layout?: ComparisonLayout;
	selected?: boolean;
	onClick?: () => void;
}

export default function LayoutIcon(props: ILayoutIconProps): ReactElement {
	const { layout, selected, onClick } = props;
	function Icon(): ReactElement {
		switch (layout) {
			case ComparisonLayout.Horizontal:
				return <TwoWaySplit />;
			case ComparisonLayout.Vertical:
				return <TwoWaySplit vertical />;
			case ComparisonLayout.HorizontalBottomSplit:
				return <ThreeWaySplit />;
			case ComparisonLayout.HorizontalTopSplit:
				return <ReverseThreeWaySplit />;
			case ComparisonLayout.VerticalRightSplit:
				return <ThreeWaySplit vertical />;
			case ComparisonLayout.VerticalLeftSplit:
				return <ReverseThreeWaySplit vertical />;
			case ComparisonLayout.VerticalThreeWaySplit:
				return <VerticalThreeWaySplit />;
			default:
				return <></>;
		}
	}

	const contentClassName: string = `layout-grid-item-content ${
		selected ? 'selected' : ''
	}`;

	function TwoWaySplit({ vertical }: { vertical?: boolean }): ReactElement {
		return (
			<Grid
				container
				className={`cursor-pointer layout-grid ${
					vertical ? 'vertical' : ''
				}`}
				onClick={onClick}
			>
				<Grid item xs={12} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
				<Grid item xs={12} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
			</Grid>
		);
	}

	function ThreeWaySplit({ vertical }: { vertical?: boolean }): ReactElement {
		return (
			<Grid
				container
				className={`cursor-pointer layout-grid ${
					vertical ? 'vertical' : ''
				}`}
				onClick={onClick}
			>
				<Grid item xs={12} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
				<Grid item xs={6} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
				<Grid item xs={6} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
			</Grid>
		);
	}

	function VerticalThreeWaySplit(): ReactElement {
		return (
			<Grid container className={`cursor-pointer layout-grid vertical`}>
				<Grid item xs={12} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
				<Grid item xs={12} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
				<Grid item xs={12} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
			</Grid>
		);
	}

	function ReverseThreeWaySplit({
		vertical
	}: {
		vertical?: boolean;
	}): ReactElement {
		return (
			<Grid
				container
				className={`cursor-pointer layout-grid ${
					vertical ? 'vertical' : ''
				}`}
				onClick={onClick}
			>
				<Grid item xs={6} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
				<Grid item xs={6} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
				<Grid item xs={12} className="layout-grid-item">
					<Box className={contentClassName} />
				</Grid>
			</Grid>
		);
	}

	return <Icon />;
}
